import { ReactElement } from 'react';
import './Unauthorized.css';

interface UnauthorizedPropTypes {
  message?: string;
}

const DEFAULT_MESSAGE =
  'The permissions you are granted for the LEA you are viewing do not allow ' +
  'you to see this page.';

const Unauthorized = ({ message }: UnauthorizedPropTypes): ReactElement => {
  return (
    <div className="page--unauthorized" data-testid="unauthorized">
      <section className="page--unauthorized-section">
        <div className="content">
          <p data-testid="unauthorized-message">
            {message || DEFAULT_MESSAGE}
          </p>
        </div>
      </section>
    </div>
  );
};

export default Unauthorized;

